class Callback {
  constructor() {
    this.singleShot = null;
    this.f = null;
    return null;
  }
}

/**
 * Wrapper to native callbacks via the 'window' object.
 */
class CallbacksManager {
  constructor() {
    this.cbs = [];
    this.install();
  }

  setCallback(event, f = () => null, singleShot = true) {
    if (!window.onNativeCallback) {
      console.error('Must call install() first');
    }

    const cb = new Callback();
    cb.f = f;
    cb.singleShot = singleShot;
    this.cbs[event] = this.cbs[event] || [];
    this.cbs[event].push(cb);
  }

  install() {
    console.log('Installing callbacks');
    window.onNativeCallback = (event, args) => this.fireCallback(event, args);
  }

  fireCallback(event, args) {
    console.log(`Firing event: ${event}`);
    const cbs = this.cbs[event] || [];

    cbs.forEach(cb => {
      if (cb.f) {
        cb.f(args);
      } else {
        console.error(`Could not execute callback for event ${event}`);
      }
    });

    // remove one-shot callbacks
    this.cbs[event] = cbs.filter(x => !x.singleShot);
  }
}

const NativeCallbacks = new CallbacksManager();
export { NativeCallbacks as default };
